"use client";

import type { ReactNode } from "react";

export interface ErrorStateProps {
  title: string;
  description?: string;
  onRetry?: () => void;
  homeHref?: string;
  labels?: {
    retry?: string;
    home?: string;
  };
  children?: ReactNode;
  className?: string;
}

export function ErrorState({
  title,
  description,
  onRetry,
  homeHref,
  labels,
  children,
  className,
}: ErrorStateProps) {
  return (
    <div
      className={[
        "flex-1 flex items-center justify-center px-4 py-20",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="max-w-md text-center">
        <p className="text-5xl mb-4" aria-hidden="true">
          &#9888;&#65039;
        </p>
        <h1 className="text-3xl font-serif font-semibold text-primary-900 mb-3">
          {title}
        </h1>
        {description && (
          <p className="text-primary-500 mb-8">{description}</p>
        )}

        {children}

        {(onRetry || homeHref) && !children && (
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            {onRetry && (
              <button
                type="button"
                onClick={onRetry}
                className="inline-flex items-center gap-2 rounded-xl bg-primary-800 px-6 py-3 text-sm font-medium text-white hover:bg-primary-700 transition-all"
              >
                {labels?.retry || "Try again"}
              </button>
            )}
            {homeHref && (
              <a
                href={homeHref}
                className="inline-flex items-center gap-2 rounded-xl border border-primary-200 bg-white px-6 py-3 text-sm font-medium text-primary-700 hover:bg-primary-50 transition-all"
              >
                {labels?.home || "Go home"}
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
